import { render, staticRenderFns } from "./PanchoWillies_defaultSection.vue?vue&type=template&id=72dd3700&scoped=true"
import script from "./PanchoWillies_defaultSection.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./PanchoWillies_defaultSection.vue?vue&type=style&index=0&id=72dd3700&prod&lang=css"
import style1 from "./PanchoWillies_defaultSection.vue?vue&type=style&index=1&id=72dd3700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd3700",
  null
  
)

export default component.exports